<template>
  <div id="app2">
    <h3 class="subtitle" style="color:white;padding:5%">{{selected}}</h3>
    <canvas id="line-chart"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import dataEurostats from "../data/all_month_eurostats.json";

export default {
  name: "App",
  dataKey:dataEurostats,
  dataToGraph: [],
  dataMonthly: null,
  dataMonthlyPrec: null,
  flowType: null,
  ville: null,
  dataOut: null,
  selectedYear: null,
  yearsDGAF: ["1999", "2004", "2009", "2014", "2019"],
  props: {
    selected: {
      type: String,
    },
    year: {
    },
    flowType: {
      type: String,
    },
  },
  dataInOut: null,
  barChartData: null,
  data() {
    return {
      gdp: [
        { country: "USA", value: 20.5 },
        { country: "China", value: 13.4 },
        { country: "Germany", value: 4.0 },
        { country: "Japan", value: 4.9 },
        { country: "France", value: 2.8 },
      ],
};
  },
  created() {
    // if (this.out != null) this.out = null;
    // if (this.in != null) this.in = null;
    this.ville = this.$props.selected;
    this.flowType = this.$props.flowType;
    this.selectedYear = this.$props.year;
    
  },
  async mounted() {
     await import("../data/all_month_eurostats.json").then((res)=>{ 
       return JSON.parse(JSON.stringify(res))
       })
      .then((e) => {
        let dataVille = null;
        let dataVillePrec = null;
        for(let i in e){
          if(i!="default" && (e[i].ville == this.ville) && (e[i].annee == this.selectedYear)){
            dataVille = e[i].array_agg[this.flowType.toUpperCase()];
          }
        }
        if(this.selectedYear != "2010"){
              for(let i in e){
          if(i!="default" && (e[i].ville == this.ville) && (e[i].annee == String((parseInt(this.selectedYear) -1)))){
            dataVillePrec = e[i].array_agg[this.flowType.toUpperCase()];
          }
        }
        }
      let dataMonthly = {};
      if(dataVille){
       Object.keys(dataVille).sort().forEach(function(key) {
        dataMonthly[key] = dataVille[key];
      });
      }
      const eurostatsTerms= {
          pas_crd: "Nombre de passagers transportés",
          pas_trs: "Nombre de passagers en transit direct",
          acm:
            "Mouvements d’avions  commerciaux et non commerciaux",
          cacm: "Mouvements d’avions commerciaux",
      };
      this.dataMonthly = dataMonthly;
      let chartLineData = null
      if(!dataVillePrec){
      chartLineData = {
        type: "line",
        data: {
          labels: [
            "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
          ],
          datasets: [
            {
              label: eurostatsTerms[this.flowType] + " par mois",
              data: [
              this.dataMonthly["1"],
              this.dataMonthly["2"],
              this.dataMonthly["3"],
              this.dataMonthly["4"],
              this.dataMonthly["5"],
              this.dataMonthly["6"],
              this.dataMonthly["7"],
              this.dataMonthly["8"],
              this.dataMonthly["9"],
              this.dataMonthly["10"],
              this.dataMonthly["11"],
              this.dataMonthly["12"],
              ],
              backgroundColor: [
                "rgba(0, 102, 255,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
              ],
              borderColor: [
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
              ],
              borderWidth: 3,
            },
          ],
        },
        options: {
          legend: {
            labels: {
                fontColor: 'white'
            }},
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  fontColor: 'white'
                },
              },
            ],
            xAxes: [
              {
                scaleLabel :{
                  display: true,
                  labelString: 'Mois',
                  fontColor: 'white'
                },
                ticks: {
                  fontColor: 'white'
                },
              },
            ],
          },
        },
      };
      }
      else{
      let dataMonthlyPrec = {};
      if(dataVillePrec){
       Object.keys(dataVillePrec).sort().forEach(function(key) {
        dataMonthlyPrec[key] = dataVillePrec[key];
      });
      }
      this.dataMonthlyPrec = dataMonthlyPrec
      chartLineData = {
        type: "line",
        data: {
          labels: [
            "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
          ],
          datasets: [
            {
              label: eurostatsTerms[this.flowType] + " en " + this.selectedYear,
              data: [
              this.dataMonthly["1"],
              this.dataMonthly["2"],
              this.dataMonthly["3"],
              this.dataMonthly["4"],
              this.dataMonthly["5"],
              this.dataMonthly["6"],
              this.dataMonthly["7"],
              this.dataMonthly["8"],
              this.dataMonthly["9"],
              this.dataMonthly["10"],
              this.dataMonthly["11"],
              this.dataMonthly["12"],
              ],
              backgroundColor: [
                "rgba(0, 102, 255,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
              ],
              borderColor: [
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
              ],
              borderWidth: 3,
            },
                        {
              label: eurostatsTerms[this.flowType] + " en " + (parseInt(this.selectedYear) -1),
              data: [
              this.dataMonthlyPrec["1"],
              this.dataMonthlyPrec["2"],
              this.dataMonthlyPrec["3"],
              this.dataMonthlyPrec["4"],
              this.dataMonthlyPrec["5"],
              this.dataMonthlyPrec["6"],
              this.dataMonthlyPrec["7"],
              this.dataMonthlyPrec["8"],
              this.dataMonthlyPrec["9"],
              this.dataMonthlyPrec["10"],
              this.dataMonthlyPrec["11"],
              this.dataMonthlyPrec["12"],
              ],
              backgroundColor: [
                "rgba(71, 183,132,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
                "rgba(54,73,93,.5)",
              ],
              borderColor: [
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
                "#36495d",
              ],
              borderWidth: 3,
            },
          ],
        },
        options: {
          legend: {
            labels: {
                fontColor: 'white'
            }},
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25,
                  fontColor: 'white'
                },
              },
            ],
            xAxes: [
              {
                scaleLabel :{
                  display: true,
                  labelString: 'Mois',
                  fontColor: 'white'
                },
                ticks: {
                  fontColor: 'white'
                },
              },
            ],
          },
        },
      };
      }

      this.createChart("line-chart", chartLineData);
      })
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
  },
};
</script>
<style>
#line-chart {
  right: 0%;
  width: 30vw;
  display: flex;
  z-index: 1;
  font-family: "Open Sans", sans-serif;
}
</style>
